import {Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges} from "@angular/core";

@Directive({
  selector: '[appBackgroundImage]'
})
export class BackgroundImageDirective implements OnChanges {

  @Input() appBackgroundImage: string | undefined;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appBackgroundImage']) {
      this.setBackgroundImage(this.appBackgroundImage);
    }
  }

  private setBackgroundImage(imageUrl: string | undefined) {
    if (imageUrl) {
      const backgroundStyle = `url(\'${imageUrl}\')`;
      this.renderer.setStyle(this.el.nativeElement, 'background', backgroundStyle);
    }
  }
}
